module.exports = __webpack_public_path__ + "img/volume-off.af1b9998.svg";